import Link, { LinkProps } from 'next/link';

import { replaceUnderscoreWithDash } from '@utils/locale';

export const LocaleLink: React.FC<LinkProps> = ({
	children,
	locale,
	...props
}) => {
	// In the urls we use a dash in the locale.
	// We need to replace a potential underscore to a dash.
	return (
		<Link
			locale={locale ? replaceUnderscoreWithDash(locale) : undefined}
			{...props}
		>
			{children}
		</Link>
	);
};
